<template>
<div>
    <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: leftcolumn }">
          <a-form :form="form">
            <a-row :gutter="24">
              <a-col :span="12" >
                <a-form-item label="Is TAX?">
                    <a-radio-group
                        buttonStyle="solid"
                        v-decorator="[
                        'is_tax',
                        { rules: [{ required: true }], initialValue: initial.is_tax },
                        ]"
                        @change="changeIsTax"
                        :disabled="formUsed=='Edit'"
                    >
                        <a-radio-button value="0">No</a-radio-button>
                        <a-radio-button value="1">Yes</a-radio-button>
                    </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="12" >
                <a-form-item label="Tax Type" v-if="trigered.tax">
                    <a-select
                        v-decorator="[
                        'tax_type',
                        {
                            rules: [{ required: true }],
                            initialValue: undefined,
                        },
                        ]"
                        @change="taxTypeChange"
                        showSearch
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        class="m-width-full"
                        :disabled="trigered.disabledtaxType"
                    >
                        <a-select-option
                            v-for="item in getType_tax"
                            :key="item.value"
                            :value="item.value"
                        >
                        {{item.text}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <!--a-form-item label="Tax Bearer Supplier?" v-if="trigered.bearer">
              <a-radio-group
                buttonStyle="solid"
                v-decorator="[
                  'tax_bearer',
                  { rules: [{ required: true }], initialValue: initial.bearer },
                ]"
                @change="changeBearer"
              >
                <a-radio-button value="1">Yes</a-radio-button>
                <a-radio-button value="0">No</a-radio-button>
              </a-radio-group>
            </!--a-form-item-->
            <a-form-item label="Invoice Detail" v-if="trigered.showppdtl">
                <a-select
                    showSearch
                    allowClear
                    @search="handleppdtl"
                    optionFilterProp="children"
                    :filterOption="filterOption"
                    v-decorator="[
                    'id_invoice_ap_ad_dtl',
                    {
                        rules: [{ required: true }],
                    },
                    ]"
                    class="m-width-full"
                    :disabled="formUsed=='Edit'"
                >
                    <a-select-option
                    v-for="item in ppdtl"
                    :key="item.id_invoice_ap_ad_dtl"
                    :value="item.id_invoice_ap_ad_dtl"
                    :disabled="item.saldo_idr<=0"
                    >
                    <div class="elipsdiv">
                      <div class="elipsdiv-mouseover-label1" >
                        {{ item.item }}</div>
                      <div class="elipsdiv-mouseover-label2">
                          <b style="float: right">{{
                              formatCurrency('IDR',parseFloat(item.saldo_idr))
                            }}
                          </b>
                      </div>
                    </div>
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="Item Name">
              <a-input
                autocomplete="off"
                v-decorator="['item_name', { rules: [{ required: true }],initialValue: initial.item_name }]"
              ></a-input>
            </a-form-item>
            <a-row :gutter="24">
              <a-col :span="qtyValue.qty_width" >
                <a-form-item label="Quantity" v-if="qtyValue.qty_show">
                  <a-input-number
                      class="m-width-full m-text-align-right"
                      v-on:keydown.enter.prevent="preventEnterButton"
                      :formatter="
                      (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                      :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      v-decorator="[
                      'quantity',
                      { rules: [{ required: true }, { validator: checkPrice }], initialValue: initial.quantity },
                      ]"
                      @change="convertingkursqty"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="qtyValue.val_width" >
                <a-form-item :label="'Value ('+data.currency_to+')'">
                  <a-input-number
                      class="m-width-full m-text-align-right"
                      :min="0"
                      @keydown="onlyNumber" 
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" 
                      :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      v-decorator="[
                      'value',
                      { rules: [{ required: true }, { validator: checkPrice }] },
                      ]"
                      @change="convertingkursvalue"
                  />
                  <!--div v-if="data.currency_from !== data.currency_to" class="m-form-description-small">Total value to {{data.currency_from}} : {{modalconvert_value}}</div-->
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="File Document TAX" v-if="trigered.tax">
                <a-upload
                    :fileList="fileList"
                    v-decorator="[
                    'file_document_tax',
                    { rules: [{ required: false }] },
                    ]"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                >
                    <a-button>
                    <a-icon type="upload" />Select File
                    </a-button>
                </a-upload>
            </a-form-item>
            <a-form-item v-if="formUsed=='Create'">
              <a-button
                @click="handleNewItem"
                block
                type="primary"
                html-type="submit"
                :loading="newLoading"
                ref="addMainBtn"
                v-decorator="['addMainBtn']"
                >Add</a-button
              >
            </a-form-item>
            <a-row :gutter="24" v-if="formUsed=='Edit'" class="margin-top">
              <a-col :span="12" >
                <a-button
                    @click="handleEditItem"
                    block
                    type="primary"
                    html-type="submit"
                    :loading="newLoading"
                    ref="addMainBtn2"
                    v-decorator="['addMainBtn']"
                    >Save Change</a-button
                  >
              </a-col>
              <a-col :span="12" >
                <a-button
                    @click="handleCancelItem"
                    block
                    type="danger"
                    html-type="submit"
                    ref="addMainBtn3"
                    v-decorator="['addMainBtn']"
                    >Cancel</a-button
                  >
              </a-col>
            </a-row>
          </a-form>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: rightcolumn }">
            <a-card class="m-height-full m-display-flex nowrap flex-column">
                <div slot="title">
                    <span>Purchase List</span>
                </div>
                <template slot="extra">
                    <a-button @click="handleExpand()">
                    <span>{{ labelExpand }}</span>
                    </a-button>
                </template>
                <div class="body-flex">
                  <a-table
                    v-if="!getScreen"
                    :columns="columns"
                    :dataSource="getCountWeb"
                    :pagination="pagination"
                    size="small"
                    :scroll="{ x: 700 }"
                    bordered
                  >
                  <template slot="ar_item_name" slot-scope="index, item">
                    {{item.item_name}}<br/>
                    <b><i><small>({{item.tax_type!=null ? getLabelTax(item.tax_type) : 'Non Tax'}})</small></i></b>
                  </template>
                  <template slot="itemPPDtl" slot-scope="index, item">
                    <b>{{item.pp_nama_barang }}</b><br/>
                    <!-- <i>{{item.kode_anggaran}}</i> -->
                  </template>
                  <template slot="unit_price" slot-scope="index, item">
                    {{formatCurrency(data.currency_to,item.value)}}
                  </template>
                  <template slot="amount" slot-scope="index, item">
                    {{formatCurrency(data.currency_to,item.value *(item.quantity ? item.quantity : 1))}}
                  </template>
                  <template slot="operation" slot-scope="index, item">
                    <div class="m-width-full">
                    <a-button-group class="m-width-full">
                      <a-button
                      class="m-width-full"
                        size="small"
                        type="primary"
                        @click="handleToEdit(item)"
                        :disabled="formUsed=='Edit' || (anypph && (item.tax_type==undefined || !item.tax_type.includes('pph')))"
                      >
                        <a-icon type="edit" />
                      </a-button>
                      <a-button type="danger"
                      class="m-width-full"
                        size="small"
                        @click="handleToDelete(item)"
                        :disabled="formUsed=='Edit' || (anypph && (item.tax_type==undefined || !item.tax_type.includes('pph')))"
                        >
                        <a-icon type="close"/>
                      </a-button>
                    </a-button-group>
                    </div>
                    <a-button
                      v-if="item.is_tax=='1' && item.document_tax != 'No File Uploaded' && item.document_tax!=undefined"
                      type="default"
                      size="small"
                      class="m-width-full" style="margin-top:5px!important"
                      @click="handleToPreview(item)"
                    >
                      <a-icon type="eye" /> View File
                    </a-button>
                    <a-button
                      v-if="item.is_tax=='1'  && (item.document_tax == 'No File Uploaded' || item.document_tax==undefined)"
                      type="default"
                      size="small"
                      class="m-width-full" style="margin-top:5px!important"
                      disabled
                    >
                      No File Upload
                    </a-button>
                  </template>
                  </a-table>
                  <div class="m-price-total">
                    <a-statistic
                      title="Total"
                      :value="formatCurrency(data.currency_to, grandTotal.all)"
                      class="margin-top m-text-align right"
                    />
                  </div>
                </div>
            </a-card>
        </a-col>
    </a-row>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "DetailPembelianPo",
  mixins: [CurrencyFormat,GlobalMethod],
  props: ["mode","ppdtl","data","parentListPurchasing"],
  components: {
    
  },
  data() {
    return {
      leftcolumn: 10,
      rightcolumn: 14,
      formUsed: "Create",
      ppdetillist: [],
      trigered : {
          percentage : false,
          tax: false,
          showppdtl: true,
          disabledtaxType:false,
          bearer:false,
      },
      fileList:[],
      labelExpand: "Expand",
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      listPurchasing: [],
      newLoading: false,
      editData: [],
      initial:{
        is_tax:"0",
        item_name:"",
        quantity:"",
        bearer:"1",
      },
      modalconvert_value: 0,
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted(){
    this.$store.dispatch("Fetch_TYPE_TAX");
    if(this.parentListPurchasing){
      this.listPurchasing = this.parentListPurchasing;
      let result = this.initialCounting(this.ppdtl,this.listPurchasing);
      Event.$emit("updateAddendumPPdtl", result.ppdtl);
    }
  },
  computed: {
    ...mapGetters([
      "getScreen","getType_tax",
    ]),
    qtyValue(){
      if(this.trigered.tax){
        return {
          qty_show: false,
          qty_width: 0,
          val_width: 24,
        };
      }else{
        return {
          qty_show: true,
          qty_width: 8,
          val_width: 16,
        }
      }
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          dataIndex: "item_name",
          width: 250,
          scopedSlots: { customRender: "ar_item_name" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Invoice Detail",
          width: 250,
          scopedSlots: { customRender: "itemPPDtl" },
          sorter: (a, b) => a.item.length - b.item.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          title: "Values",
          align: "right",
          key: "hargaTotal",
          width: 150,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "Total Value",
          key: "amount",
          align: "right",
          width: 150,
          scopedSlots: { customRender: "amount" },
        },
        {
          title: "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 125,
          align: "center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      //let data = _.filter(this.listPurchasing,(item) => item.values.is_item == "yes");
      let data = [...this.listPurchasing];
      if (data) {
        data.forEach((value, index) => {
          data[index]["no"] = index + 1;
          if(value.tax_type && value.tax_type.includes("pph" && value.tax_type!="pph_22_impor")){
            data[index]["key"] = "pphgrid" + (index + 1);
          }else{
            data[index]["key"] = "agrid" + (index + 1);
          }

          data[index]["item_name"] = value.item_name;

          let temp = _.filter(this.ppdtl, (item)=> item.id_invoice_ap_ad_dtl==value.id_invoice_ap_ad_dtl)
          data[index]["pp_nama_barang"]   = temp.length>0 ? temp[0].item :null;
          data[index]["pp_kode_anggaran"] = temp.length>0 ? temp[0].kode_anggaran : null;
          data[index]["pp_detail"]        = temp.length>0 ? temp[0].item :null;

          data[index]["quantity"] = value.quantity;
          data[index]["value"] = value.values;
        });
      }
      return data;
    },
    grandTotal() {
      let data = [...this.listPurchasing];
      let result  = {
        item: 0,
        all:0,
      };
      if (data) {
        data.forEach((value) => {
          result.item = !(value.tax_type && value.tax_type.includes("pph") && value.tax_type!="pph_22_impor") ? result.item+(value.value*this.data.rate) : result.item;
          result.all = result.all + (((value.tax_type && value.tax_type.includes("pph") && value.tax_type!="pph_22_impor") ? -1 : 1)
            *Number(value.value*(value.quantity ? value.quantity : 1)));
        });
      }
      return result;
    },
    anypph(){
      let data = [...this.listPurchasing];
      let result  = false;
      if (data) {
        data.forEach((value) => {
          if(value.tax_type && value.tax_type.includes("pph") && value.tax_type!="pph_22_impor"){
            result=true;
          }
        });
      }
      return result;
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleppdtl(){

    },
    handleOption(){

    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    convertinghrg(val) {
      let vinput = this.form.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (val ? val : vinput.harga) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (vinput.cur_type == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot = ((this.totalPrice * val) / 100) * parseFloat(this.kurs);
          } else {
            tot =
              (((this.totalPrice - this.totalDiscList) * val) / 100) *
              parseFloat(this.kurs);
          }
        }
      }
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    taxTypeChange(val){
      //console.log(val)
      if(val.includes("pph")){
        this.trigered.showppdtl = false;
        this.trigered.bearer = true;
      }else{
        this.trigered.showppdtl = true;
        this.trigered.bearer = false;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    handleRemove() {
        this.fileList = [];
    },
    handleExpand() {
      if (this.leftcolumn == 10 && this.rightcolumn == 14) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
      } else {
        this.leftcolumn = 10;
        this.rightcolumn = 14;
        this.labelExpand = "Expand";
      }
    },
    handleNewItem(){
      this.form.validateFields((err, val) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

      let grandtotal=0;
      for (let i = 0; i < this.listPurchasing.length; i++) {
        if(this.listPurchasing[i].id_invoice_ap_ad_dtl && this.listPurchasing[i].id_invoice_ap_ad_dtl !="null"){
          grandtotal += Number(this.listPurchasing[i].value)*
            (this.listPurchasing[i].quantity ? Number(this.listPurchasing[i].quantity) : 1);
        }
      }
      if(val.tax_type && val.tax_type.includes('pph') && grandtotal==0){
        this.displayMessageValue(
          "basic-error",
          "Cannot add PPH type items, because Total item is empty!"
        );
      }

      if (val.id_invoice_ap_ad_dtl) {
          let exis = _.filter(
            this.listPurchasing,
            (item) => item.id_invoice_ap_ad_dtl == val.id_invoice_ap_ad_dtl
          );
          if (exis.length > 0) {
            this.newLoading = false;
            this.displayMessageValue(
              "error-other",
              "Invoice Detil have been Used, data can only be edited!"
            );
            return;
          }
        }
      
      if(this.anypph && !(val.tax_type && val.tax_type.includes('pph'))){
        this.displayMessageValue(
                "basic-error",
                "Cannot add items because there is a tax of the PPH type, so delete the PPH type tax first!"
              );
      }else{

          let tp = [];
          for (let i = 0; i < this.listPurchasing.length; i++) {
            tp.push({...this.listPurchasing[i]});
          }

          let id_pp_dtl = _.filter(this.ppdtl,(item)=>item.id_invoice_ap_ad_dtl == val.id_invoice_ap_ad_dtl)
          let dt = {
            is_tax: val.is_tax,
            id_pp_dtl: id_pp_dtl.length>0 ? id_pp_dtl[0].id_pp_dtl : undefined,
            id_invoice_ap_ad_dtl: val.id_invoice_ap_ad_dtl,
            item_name: val.item_name,
            quantity : val.quantity,
            value: val.value,
            values: val.value,
            option: 'nominal',
            percentage: null,
            tax_type: val.tax_type,
            file_document_tax: this.fileList
          };
          tp.push(dt);
          let dd = [...this.ppdtl]
          let validate = this.initialCounting(dd,tp);
          if(validate.valid){
            //let tempppdtl = this.ppdtl;
            //let index = _.findIndex(tempppdtl, {id_pp_dtl: val.pp_detail});

            this.listPurchasing.push(dt);

            // if(val.is_tax=="1" && val.tax_type.includes("pph")){
            //   tempppdtl = validate.value;
            // }else{
            //   tempppdtl[index].saldo = validate.value;
            // }
            this.resetInput();
            //Event.$emit("updateAddendumPPdtl", tempppdtl);

            //recounting hasil akhir perhitungan
            Event.$emit("updateAddendumPPdtl", validate.ppdtl);
          }else{
            if (validate.grandtotalminus){
              this.displayMessageValue(
                "basic-error",
                "The value can't exceed the Total value!"
              );
            }else{
              this.displayMessageValue(
                "basic-error",
                "Budget Invoice Detail is not enough!"
              );
            }
          }
        }
      });
    },
    handleEditItem(){
      this.form.validateFields((err, val) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
        
        let tp = [];
        for (let i = 0; i < this.listPurchasing.length; i++) {
          tp.push({...this.listPurchasing[i]});
        }
        let no = _.findIndex(tp, {key: this.editData.key});
        tp[no].quantity = val.quantity;
        tp[no].value = val.value;

        let validate = this.initialCounting(this.ppdtl,tp);
          if(validate.valid){
            let idx = _.findIndex(this.listPurchasing, {key: this.editData.key});

            this.listPurchasing[idx].item_name = val.item_name;
            this.listPurchasing[idx].quantity = val.quantity;
            this.listPurchasing[idx].value = val.value;
            this.listPurchasing[idx].values = val.value;
            this.listPurchasing[idx].document_file = "";
            this.listPurchasing[idx].document_path = "";

            if(this.fileList && this.fileList.length>0){
              this.listPurchasing[idx].document_tax = this.fileList[0].name;
              this.listPurchasing[idx].file_doc_tax = this.fileList[0].name;
              this.listPurchasing[idx].file_document_tax= this.fileList;
            }else{
              this.listPurchasing[idx].document_tax = "No File Uploaded";
              this.listPurchasing[idx].file_doc_tax = "";
              this.listPurchasing[idx].file_document_tax= "";
            }

            this.trigered.disabledtaxType = false;
            Event.$emit("addendumSetDisabledButton", {disabledPrev:false,disabledNext:false});
            this.resetInput();
            Event.$emit("updateAddendumPPdtl", validate.ppdtl);
          }else{
            if (validate.grandtotalminus){
              this.displayMessageValue(
                "basic-error",
                "The value can't exceed the Total value!"
              );
            }
            else {
              this.displayMessageValue(
                "basic-error",
                "Budget Invoice Detail is not enough!"
              );
            }
          }
      });
    },
    handleCancelItem(){
      let tempppdtl = null;
      this.trigered.disabledtaxType = false;
      Event.$emit("updateAddendumPPdtl", tempppdtl);
      if(this.editData.is_tax=="1" && this.editData.tax_type.includes("pph")){
        tempppdtl = this.editData['orippdtl'];
      }else{
        tempppdtl = this.ppdtl;
        let index = _.findIndex(tempppdtl, { id_invoice_ap_ad_dtl: this.editData.id_invoice_ap_ad_dtl });
        tempppdtl[index].saldo_idr = this.editData.originalppdlvalue;
      }
      Event.$emit("updateAddendumPPdtl", tempppdtl);
      Event.$emit("addendumSetDisabledButton", {disabledPrev:false,disabledNext:false});
      this.resetInput();
    },
    changeIsTax(val){
      this.trigered.tax = val.target.value=='1'? true : false;
      this.trigered.showppdtl = val.target.value=='1'? false : true;
      this.fileList = [];
      this.$nextTick(function () {
        this.form.setFieldsValue({
          tax_type: undefined,
          file_document_tax: undefined
        });
      });
    },
    getLabelTax(val){
      let result = _.filter(this.getType_tax,(item) => item.value==val);
      return result.length>0 ? result[0].text : "";
    },
    resetInput(){
      this.form.resetFields();
      this.formUsed = "Create";
      this.initial.is_tax = "0";
      this.trigered.tax = false;
      this.trigered.bearer = false;
      this.trigered.showppdtl = true;
      this.initial.item_name = "";
      this.initial.bearer = "1";
      this.initial.quantity = "";
      this.editData = [];
      this.fileList = [];
      this.modalconvert_value= 0;
    },
    handleToEdit(item){
      this.editData = item;
      let tempppdtlori = [];
      this.trigered.disabledtaxType = true;
      for (let i = 0; i < this.ppdtl.length; i++) {
        tempppdtlori.push({...this.ppdtl[i]});
      }
      this.editData['orippdtl'] = tempppdtlori;
      let tempppdtl = this.ppdtl;
      if (item.tax_type && item.tax_type.includes("pph")){
        if(item.id_invoice_ap_ad_dtl != undefined && item.id_invoice_ap_ad_dtl != "null" && item.id_invoice_ap_ad_dtl != "undefined"){
          for (let i = 0; i < this.listPurchasing.length; i++) {
            if (this.listPurchasing[i].id_invoice_ap_ad_dtl != undefined && this.listPurchasing[i].id_invoice_ap_ad_dtl != "null"
            && this.listPurchasing[i].id_invoice_ap_ad_dtl != "undefined") {
              let dtlpp = this.listPurchasing[i].id_invoice_ap_ad_dtl;
              let indx  = _.findIndex(tempppdtl, (e) => { 
                          return e.id_invoice_ap_ad_dtl == dtlpp; }, 0);
              let tempval = (Number(tempppdtl[indx].saldo_idr) - (((item.value/this.data.rate)/this.grandTotal.all)*this.listPurchasing[i].value));
              // if(tempval<0){
              //   this.displayMessageValue(
              //     "basic-error",
              //     "Budget Invoice Detail is not enough!"
              //   );
              //   return;
              // } else{
                  tempppdtl[indx].saldo_idr = tempval;
                  Event.$emit("updateAddendumPPdtl", tempppdtl);
              // }
            }
          }
        }
      } else{
        let index = _.findIndex(tempppdtl, (e) => { 
                      return e.id_invoice_ap_ad_dtl == item.id_invoice_ap_ad_dtl; }, 0);
        this.editData.originalppdlvalue = tempppdtl[index].saldo_idr;
        tempppdtl[index].saldo_idr = Number(tempppdtl[index].saldo_idr)+
        Number((this.data.currency_from==this.data.currency_to ? item.value : (Number(item.value)/this.data.rate))*(item.quantity?item.quantity:1));
        Event.$emit("updateAddendumPPdtl", tempppdtl);
      }

      this.form.resetFields();
      this.formUsed="Edit";
      if (item.pp_detail){
        this.$nextTick(function () {
          this.form.setFieldsValue({
            is_tax: item.is_tax,
            value: item.value,
            tax_type: item.tax_type,
            id_invoice_ap_ad_dtl: item.id_invoice_ap_ad_dtl,
            //file_document_tax: item.file_document_tax,
          });
        });
        this.initial.item_name = item.item_name;
        this.initial.quantity = item.quantity;
      }else{
        this.$nextTick(function () {
          this.initial.is_tax = item.is_tax;
          this.initial.item_name = item.item_name;
          this.initial.quantity = item.quantity;
          this.form.setFieldsValue({
            value: item.value,
            tax_type: item.tax_type,
            // is_tax: item.is_tax,
          });
        });
      }
      this.trigered.tax = item.tax_type ? true : false;
      this.trigered.showppdtl = item.pp_detail && item.pp_detail!="null" ? true : false;

      if (item.document_tax && item.document_tax != 'No File Uploaded'){
        this.fileList = item.file_doc_tax;
      }

      this.resultConverting(item.quantity,item.value);

      Event.$emit("addendumSetDisabledButton", {disabledPrev:true,disabledNext:true});
    },
    handleToDelete(item){
      let temp = _.filter(this.listPurchasing,(el)=> el.key!=item.key);

      let tp = [];
        for (let i = 0; i < temp.length; i++) {
          tp.push({...temp[i]});
        }

      let result = this.initialCounting(this.ppdtl,tp);
      if(result.valid){
        Event.$emit("updateAddendumPPdtl", result.ppdtl);
        this.listPurchasing = _.filter(this.listPurchasing,(el)=> el.key!=item.key);
      }else if(!result.valid){
        this.displayMessageValue(
          "basic-error",
          "Budget Invoice Detail is not enough!"
        );
        return;
      }else if(result.grandtotalminus){
        this.displayMessageValue(
          "basic-error",
          "The value can't exceed the Total value!"
        );
        return;
      }
    },
    handleRef() {
      Event.$emit("addendumEmitChild", {
        value: this.listPurchasing,
        grandtotal:this.grandTotal.all
      });
    },
    handleToPreview(val){
      let blob = new Blob([val.file_document_tax[0]], { type: val.file_document_tax[0].type }),
        url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    initialCounting(lsdtl,listPurchasing){
      let ppdtl = [];
      // let vppdtl = [...lsdtl];
      
      for (let t = 0; t < lsdtl.length; t++) {
        ppdtl.push({...lsdtl[t]});
      }

      //listPurchasing.sort((a, b) => (a.pp_detail ? a.pp_detail :"z9").localeCompare(b.pp_detail ? b.pp_detail :"z9"));

      //reset nilai ppdtl sesuai nilai origin
      for (let b = 0; b < ppdtl.length; b++) {
        ppdtl[b].saldo_idr = Number(ppdtl[b].saldo_ori_idr);
      }
      //get grandtotal
      let grandtotal=0;
      let grandtotalpph = 0;
      for (let w = 0; w < listPurchasing.length; w++) {
        if (listPurchasing[w].id_invoice_ap_ad_dtl && listPurchasing[w].id_invoice_ap_ad_dtl != "null"
        && listPurchasing[w].id_invoice_ap_ad_dtl != "undefined") {
          grandtotal += Number(listPurchasing[w].values)*
            (listPurchasing[w].quantity ? Number(listPurchasing[w].quantity) : 1);
        }
      }

      let valid = true;
      let grandtotalminus = false;
      for (let i = 0; i < listPurchasing.length; i++) {
        if (listPurchasing[i].tax_type && listPurchasing[i].tax_type.includes("pph")){
          let val = (Number(listPurchasing[i].value)*(listPurchasing[i].quantity ? listPurchasing[i].quantity : 1))/Number(this.data.rate);
          grandtotalpph += val;
          grandtotal = grandtotal-val;
          if (listPurchasing[i].id_invoice_ap_ad_dtl != undefined && listPurchasing[i].id_invoice_ap_ad_dtl != "null" 
          && listPurchasing[i].id_invoice_ap_ad_dtl != "undefined") {
            let index = _.findIndex(ppdtl, { id_invoice_ap_ad_dtl: listPurchasing[i].id_invoice_ap_ad_dtl });
            let values = Number(listPurchasing[i].value)*Number(listPurchasing[i].quantity ? listPurchasing[i].quantity : 1)/Number(this.data.rate);
            let hsl = (ppdtl[index].saldo_idr - (((this.data.currency_from == this.data.currency_to ? values : values))));
            ppdtl[index].saldo_idr = hsl;
          }
          else {
            for (let i2 = 0; i2 < listPurchasing.length; i2++) {
              if (listPurchasing[i2].id_invoice_ap_ad_dtl != undefined && listPurchasing[i2].id_invoice_ap_ad_dtl != "null"
              && listPurchasing[i].id_invoice_ap_ad_dtl != "undefined") {
                //let indx = _.findIndex(ppdtl, { id_invoice_ap_ad_dtl: listPurchasing[i2].id_invoice_ap_ad_dtl });
                // let tempval = ((ppdtl[indx].saldo + ((val/(grandtotal+val)) 
                //               *(listPurchasing[i2].value*(listPurchasing[i2].quantity ? listPurchasing[i2].quantity : 1)))));

                if (grandtotal <= 0) {
                    grandtotalminus = true;
                    //ppdtl[indx].saldo = tempval;
                  } else {
                    //ppdtl[indx].saldo = tempval
                  }
                }
            }
          }
        } else {
          let index = _.findIndex(ppdtl, { id_invoice_ap_ad_dtl: listPurchasing[i].id_invoice_ap_ad_dtl });
          let values = Number(listPurchasing[i].value) * Number(listPurchasing[i].quantity ? listPurchasing[i].quantity : 1) / Number(this.data.rate);
          let hsl = (ppdtl[index].saldo_idr - (((this.data.currency_from == this.data.currency_to ? values : values))));
          //console.log(ppdtl[index].saldo,hsl)
          ppdtl[index].saldo_idr = hsl;
        }
      }
      //cek ppdtl apakah ada yang minus
      for (let q = 0; q < ppdtl.length; q++) {
        if(ppdtl[q].saldo_idr <0 && this.formUsed!='Edit'){
          valid = false;
        } else if(ppdtl[q].saldo_idr <0 && this.formUsed=='Edit' && ppdtl[q].id_invoice_ap_ad_dtl==this.editData.id_invoice_ap_ad_dtl){
          valid = false;
        }
      }
      
      if(grandtotal-grandtotalpph < 0 ){
        if(ppdtl[q].saldo_idr <0 && this.formUsed!='Edit'){
          valid = false;
        } else if(ppdtl[q].saldo_idr <0 && this.formUsed=='Edit' && ppdtl[q].id_invoice_ap_ad_dtl==this.editData.id_invoice_ap_ad_dtl){
          valid = false;
        }
        grandtotalminus = true;
      }
      return {valid,ppdtl,grandtotalminus};
    },
    changeBearer(val){
      if(val.target.value=="0"){
        this.trigered.showppdtl = true;
      }else{
        this.trigered.showppdtl = false;
      }
    },
    convertingkursqty(qty){
      let vinput = this.form.getFieldsValue();
      this.resultConverting(qty,vinput.value)
    },
    convertingkursvalue(val){
      let vinput = this.form.getFieldsValue();
      this.resultConverting(vinput.quantity ? vinput.quantity : 1,val)
    },
    resultConverting(qty,val){
      this.modalconvert_value = this.formatCurrency(this.data.currency_from,((qty ? qty : 0)*(val ? val : 0))/(this.data.rate ? this.data.rate : 1));
    }
  }
}
</script>